import React from "react";
import { Layout, Typography } from "antd";

import HeaderBar from "./HeaderBar";
import Footerbar from "../sections/Footerbar";

const { Title, Paragraph } = Typography;

const contentStyle = {
  textAlign: "center",
  backgroundColor: "white",
  borderRadius: "12px",
  border: "1px solid #E5E7EB",
  marginTop: 18,
  padding: "2.5rem",
  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
};

export default function ContactUs() {
  return (
    <>
      <div className="layout-default ant-layout layout-sign-up">
        <HeaderBar />

        <div
          className="landing-header absolute w-full z-0"
          style={{
            position: "absolute",
            width: "100%",
            zIndex: 0,
          }}
        >
          <div className="content">
            <Title level={1} style={{color: 'black'}}>
              Contact Us
            </Title>
          </div>
        </div>

        <div
          className="p-0 my-16 mx-auto max-w-2xl"
          style={{
            zIndex: 20,
            marginTop: "11rem",
          }}
        >
          <div style={contentStyle}>
            <Title level={3} className="text-gray-900">
              🏢 SAWARI PAKISTAN LIMITED
            </Title>
            <Paragraph className="text-gray-700 leading-relaxed">
              R1, 179 Bordesley Green East,
              <br />
              Birmingham, West Midlands,
              <br />
              England, B9 5SR
              <br />
              United Kingdom
            </Paragraph>
            <Paragraph className="font-semibold text-gray-800 text-lg">
              📌 Company No: 14810746
            </Paragraph>

            <div className="border-t border-gray-300 my-6"></div>

            <Title level={4} className="text-gray-900">📬 Contact Information</Title>
            <Paragraph className="text-gray-700">
              <strong>✉️ Email:</strong>{" "}
              <a href="mailto:hello@sawaripakistan.com" className="text-blue-600 hover:underline">
                hello@sawaripakistan.com
              </a>
            </Paragraph>
            <Paragraph className="text-gray-700">
              <strong>🌐 Website:</strong>{" "}
              <a href="https://www.sawaripakistan.com" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                www.sawaripakistan.com
              </a>
            </Paragraph>
            <Paragraph className="text-gray-700">
              <strong>📞 Contact:</strong> <span className="font-medium">0092 335 4400044</span>
            </Paragraph>
          </div>
        </div>

        <Footerbar bgColorClass="bg-neutral-light" />
      </div>
    </>
  );
}
